<template>
  <!-- 案件详情-申请资料 -->
  <div class="container-situation flex">
    <el-card
      v-if="checkPermission('申请信息:查看', permList)"
      class="situation-list"
    >
      <div slot="header" class="clearfix">
        <span class="bold">申请信息</span>
      </div>
      <div class="message-block">
        <p class="list-txt">
          事件ID：<span class="txt">{{ caseInfo.caseId }}</span>
        </p>
        <p class="list-txt">
          受助人名称：<span class="txt">{{ caseInfo.recRealName }}</span>
        </p>
        <p class="list-txt">
          申请时间：<span class="txt">{{ caseInfo.createTime }}</span>
        </p>
        <p
          v-if="caseInfo && typeof caseInfo.caseRisk == 'string'"
          class="list-txt"
        >
          案件风险：<span class="txt">{{ caseInfo.caseRisk }}</span>
        </p>
        <p v-if="caseInfo && caseInfo.recApplyList" class="list-txt">
          申请次数：
          <template>
            <p
              v-if="caseInfo.recApplyList.length > 1"
              class="txt underline-txt"
              @click="onShowApplicationDialog"
            >
              {{ caseInfo.recApplyList.length }}次
            </p>
            <span v-else class="txt">{{ caseInfo.recApplyList.length }}次</span>
          </template>
        </p>
        <p
          v-if="
            caseInfo &&
              caseInfo.caseId &&
              typeof caseInfo.isSpecial === 'boolean'
          "
          class="list-txt"
        >
          是否特殊案件：<span :class="caseInfo.isSpecial ? 'txt red' : 'txt'">{{
            caseInfo.isSpecial ? "特殊案件" : "普通案件"
          }}</span>
        </p>
      </div>
    </el-card>
    <el-card
      v-if="checkPermission('计划情况:查看', permList)"
      class="situation-list"
    >
      <div slot="header" class="clearfix">
        <span class="bold">计划情况</span>
      </div>
      <div class="message-block">
        <p class="list-txt">
          所属计划：<span class="txt">{{ caseInfo.productName }}</span>
        </p>
        <p class="list-txt">
          加入时间：<span class="txt">{{ caseInfo.joinTime }}</span>
        </p>
        <p class="list-txt">
          生效时间：<span
            class="txt"
          >{{ caseInfo.effectiveTime
          }}<span
            v-if="caseInfo.waitingDateFlag"
            class="state"
          >（{{ caseInfo.waitingDateFlag }}）</span></span>
        </p>
        <p class="list-txt">
          截止到确诊或事故发生时时加入时长：<span
            class="txt"
          >{{ caseInfo.allJoinTime }}天</span>
        </p>
        <p v-if="caseInfo.joinExitInfos" class="list-txt">
          计划加入次数：
          <template>
            <el-popover placement="bottom" width="700" trigger="click">
              <div style="padding: 5px 15px; max-height: 400px; overflow-y: auto;">
                <div v-if="caseInfo.joinExitInfos[0].joinTimes.length && isCaseType == 'cancer'" class="join-exit-block">
                  <p class="plan-title">抗癌互助计划</p>
                  <el-table :data="joinExitTableData(0)" size="mini" border style="width: 100%">
                    <el-table-column prop="joinTime" label="加入时间" />
                    <el-table-column prop="joinSource" label="加入方式" />
                    <el-table-column prop="exitTime" label="退出时间" />
                    <el-table-column prop="exitReason" label="退出原因" />
                  </el-table>
                </div>
                <div v-if="caseInfo.joinExitInfos[1].joinTimes.length && isCaseType == 'accident'" class="join-exit-block">
                  <p class="plan-title">意外互助计划</p>
                  <el-table :data="joinExitTableData(1)" size="mini" border style="width: 100%">
                    <el-table-column prop="joinTime" label="加入时间" />
                    <el-table-column prop="joinSource" label="加入方式" />
                    <el-table-column prop="exitTime" label="退出时间" />
                    <el-table-column prop="exitReason" label="退出原因" />
                  </el-table>
                </div>
              </div>
              <p slot="reference" class="txt underline-txt">
                {{ planJoinNums }}次
              </p>
            </el-popover>
          </template>
        </p>
      </div>
    </el-card>
    <el-card
      v-if="checkPermission('审核状态:查看', permList)"
      class="situation-list"
    >
      <div slot="header" class="clearfix">
        <span class="bold">审核状态</span>
      </div>
      <div class="message-block">
        <p class="list-txt">
          当前进度：<span class="txt">{{ caseInfo.currentFlowName }}</span>
        </p>
        <p class="list-txt">
          立案时间：<span class="txt">{{ caseInfo.caseFilingTime }}</span>
        </p>
        <p class="list-txt">
          是否调查：<span class="txt">{{ surveyPayResult }}</span>
        </p>
        <p class="list-txt">
          缴费情况：<span
            class="txt"
          >{{ caseInfo.surveyFeeStatus || "无" }}（应缴{{
            caseInfo.surveyFee || 0
          }}元/实缴{{ caseInfo.realSurveyFee || 0 }}元）</span>
        </p>
        <p class="list-txt">
          审核结论：<span
            class="txt red"
          >{{ auditConclusion.name
          }}<template
            v-if="auditConclusion.approveRemark"
          >（{{ auditConclusion.approveRemark }}）</template></span>
        </p>
        <p class="list-txt">
          最高互助金额：<span
            v-if="caseInfo && caseInfo.mutualMoney > 10000"
            class="txt red"
          >{{ getMutualMoneyWan }}万元</span>
          <span v-else class="txt red">{{ caseInfo.mutualMoney }}元</span>
          <el-button
            v-if="
              isKaPlanState &&
                checkPermission('少儿呼吸首:最高互助金费用计算', permList)
            "
            type="primary"
            size="small"
            class="button-block"
            @click="calcHelpMoneyBtn"
          >
            费用计算
          </el-button>
        </p>
        <p class="list-txt">
          累计支出均摊金额：<span v-if="caseInfo && caseInfo.historySpentAmount > 10000" class="txt red">{{ getHistorySpentMoneyWan }}万元</span>
          <span v-else class="txt red">{{ caseInfo.historySpentAmount }}元</span>
        </p>
      </div>
    </el-card>
    <el-card
      v-if="checkPermission('时效管理:查看', permList)"
      class="situation-list"
    >
      <div slot="header" class="clearfix">
        <span class="bold">时效管理</span>
      </div>
      <div class="message-block">
        <template
          v-if="
            caseInfo &&
              caseInfo.caseWarnResInfo &&
              caseInfo.caseWarnResInfo.list.length
          "
        >
          <p
            v-for="(item, index) in caseInfo.caseWarnResInfo.list"
            :key="index"
            class="list-txt"
          >
            {{ item.title }}：<span>
              <span v-if="item.currentTimes > item.times" style="color: red">{{
                item.currentTimes
              }}</span>
              <span v-else>{{ item.currentTimes }}</span>
              /
              <span>{{ item.times }}</span>
              <span class="marginL5">
                <span v-if="item.type == 1">工作日</span>
                <span v-else-if="item.type == 2">自然日</span>
              </span>
            </span>
          </p>
        </template>
        <p class="list-txt">
          受助人120天操作时效：<span
            class="txt"
          ><span
            :style="
              onCountingDays(caseInfo.createTime) > 120 ? 'color: red' : ''
            "
          >{{ onCountingDays(caseInfo.createTime) || 0 }}</span>
            / 120<span class="marginL5">自然日</span>
          </span>
        </p>
      </div>
    </el-card>

    <!-- 2021年7月27日新增 -->
    <el-card
      v-if="checkPermission('委派公估备注:查看', permList)"
      class="situation-list"
    >
      <div slot="header" class="clearfix">
        <span class="bold">委派公估备注</span>
      </div>
      <div class="message-block">
        <p v-if="publicAssessmentRemark" class="list-txt">
          {{ publicAssessmentRemark }}
        </p>
        <div v-else class="null-block flex">
          <i class="icons el-icon-tickets" />
          暂无相关记录
        </div>
      </div>
    </el-card>

    <!-- 少儿呼吸道-费用计算-弹出窗 -->
    <el-dialog
      title="费用计算"
      width="380px"
      class="container-dialog calculate-dialog"
      custom-class="c-p"
      :visible.sync="calcHelpMoneyDialog"
    >
      <div class="calculate-dialog-content">
        <div class="search-con-item flex">
          <label class="search-con-item__label">治疗总额</label>
          <div class="search-con-item__input">
            <el-input
              v-model="calcHelpMoneyBak.cureTotal"
              size="small"
              placeholder="治疗总额"
              @change="changeHelpMoney"
            >
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
        <div class="search-con-item flex">
          <label class="search-con-item__label">社保报销</label>
          <div class="search-con-item__input">
            <el-input
              v-model="calcHelpMoneyBak.socialSecurityExpense"
              size="small"
              placeholder="社保报销"
              @change="changeHelpMoney"
            >
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
        <div class="search-con-item flex">
          <label class="search-con-item__label">第三方报销</label>
          <div class="search-con-item__input">
            <el-input
              v-model="calcHelpMoneyBak.thirdPartyExpense"
              size="small"
              placeholder="第三方报销"
              @change="changeHelpMoney"
            >
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">互助金额</label>
          <span>{{ calcHelpMoneyBak.mutualMoney }}元</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCalculateHelpMoney">确定</el-button>
        <el-button @click="rollbackCalcHelpMoney">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 申请次数-查看以往申请案件编号-弹出窗 -->
    <el-dialog
      title="查看以往申请案件编号"
      class="container-dialog application-dialog"
      custom-class="c-p"
      :visible.sync="applicationDialog"
      width="35%"
    >
      <div class="content-block flex">
        <p
          v-for="(item, index) in caseInfo.recApplyList"
          :key="index"
          class="list-block"
          @click="onNavsToCaseDetail(index)"
        >
          {{ item }}
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="onHideApplicationDialog"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NP from 'number-precision' // 使用js精确地执行加法、减法、乘法和除法运算

export default {
  name: 'ApplicationMaterials',

  props: {
    // 是否需要调查
    surveyPayResult: {
      type: String,
      default: () => {
        return ''
      }
    },
    // 审计结论
    auditConclusion: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      applicationDialog: false, // 控制申请次数-查看以往申请案件编号弹窗的显示/隐藏
      calcHelpMoneyDialog: false, // 控制少儿呼吸道-费用计算弹出窗的显示/隐藏
      calcHelpMoneyBak: {}, // 费用计算数据
      operatingTime: '0' // 受助人120天操作时效
    }
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList
    }),

    /**
     * 判断抗癌计划的状态
     */
    isKaPlanState() {
      const { caseInfo, checkPermission, permList } = this
      const { productName, diseaseIcdInfo, flowCode } = caseInfo

      if (
        checkPermission('初审:互助信息:可改', permList) &&
        caseInfo &&
        productName &&
        productName.substring(0, 2) === '抗癌' &&
        diseaseIcdInfo !== undefined &&
        diseaseIcdInfo !== null &&
        Number(diseaseIcdInfo.degreeType) === 1 &&
        ((flowCode + '').substring(0, 4) === '1000' ||
          (flowCode + '').substring(0, 4) === '1005' ||
          (flowCode + '').substring(0, 4) === '1010' ||
          (flowCode + '').substring(0, 4) === '1015') &&
        flowCode + '' !== '101570'
      ) {
        return true
      } else {
        return false
      }
    },

    /**
     * 委派公估备注
     */
    publicAssessmentRemark() {
      let {
        caseInfo: { publicAssessment }
      } = this

      if (publicAssessment) {
        publicAssessment = JSON.parse(publicAssessment)
        return publicAssessment.listDetail.remark
      } else {
        return ''
      }
    },

    /**
     * 获取最高互助金额值(万元单位)
     */
    getMutualMoneyWan() {
      const {
        caseInfo: { mutualMoney }
      } = this

      if (mutualMoney) {
        return NP.divide(mutualMoney, 10000)
      } else {
        return ''
      }
    },

    /**
     * 获取过往支出(万元单位)
     */
    getHistorySpentMoneyWan() {
      const {
        caseInfo: { historySpentAmount }
      } = this

      if (historySpentAmount) {
        return NP.divide(historySpentAmount, 10000)
      } else {
        return ''
      }
    },

    /**
     * 判断案件类型（抗癌、意外）
     */
    isCaseType() {
      const { productName } = this.caseInfo;
      return productName && productName.substring(0, 2) === "抗癌" ? 'cancer' : 'accident';
    },

    /**
     * 计算计划加入次数
     */
    planJoinNums() {
      let nums = 0
      const { joinExitInfos } = this.caseInfo
      if (this.isCaseType === 'cancer') {
        nums = joinExitInfos[0].joinTimes.length
      } else {
        nums = joinExitInfos[1].joinTimes.length
      }
      return nums
    }
  },

  methods: {
    /**
     * 少儿呼吸道-最高互助金额-显示费用计算的弹出层
     */
    calcHelpMoneyBtn() {
      const {
        cureTotal,
        socialSecurityExpense,
        thirdPartyExpense,
        mutualMoney
      } = this.caseInfo
      const calcHelpMoneyBak = {
        cureTotal,
        socialSecurityExpense,
        thirdPartyExpense,
        mutualMoney
      }

      this.calcHelpMoneyDialog = true
      this.calcHelpMoneyBak = calcHelpMoneyBak
    },

    /**
     * 少儿呼吸道-最高互助金额-保存，并隐藏弹出层
     */
    async onCalculateHelpMoney() {
      const _this = this
      const { caseCode, detailVersion } = _this.caseInfo
      const { cureTotal, socialSecurityExpense, thirdPartyExpense } =
        _this.calcHelpMoneyBak

      const params = {
        caseCode,
        cureTotal,
        detailVersion,
        socialSecurityExpense,
        thirdPartyExpense
      }

      try {
        const { data: result } = await _this.axios.put(
          `/case-info/children-breath`,
          params
        )
        if (result && result.status === '000000') {
          _this.calcHelpMoneyDialog = false
          _this.$emit('fetchCaseInfo')
        } else {
          _this.$alert(
            (result && result.message) || '服务器繁忙，请稍后重试',
            '提示'
          )
        }
      } catch (error) {
        console.log('少儿呼吸道-请求失败', error)
      }
    },

    /**
     * 最高互助金额-隐藏费用计算的弹出层
     */
    rollbackCalcHelpMoney() {
      this.calcHelpMoneyDialog = false
    },

    /**
     * 限制费用计算-治疗总额的金额，最高只能填写“10000”
     */
    onChangeCureTotal(value) {
      const { calcHelpMoneyBak } = this
      let cureTotal = value
      if (Number(value) > 10000) cureTotal = 10000

      calcHelpMoneyBak.cureTotal = cureTotal
      this.calcHelpMoneyBak = JSON.parse(JSON.stringify(calcHelpMoneyBak))
    },

    /**
     * 计算最高互助金
     */
    changeHelpMoney() {
      const { cureTotal, socialSecurityExpense, thirdPartyExpense } =
        this.calcHelpMoneyBak

      const { calcHelpMoneyBak } = this
      // const mutualMoney = cureTotal - socialSecurityExpense - thirdPartyExpense
      let mutualMoney = NP.minus(
        cureTotal || 0,
        socialSecurityExpense || 0,
        thirdPartyExpense || 0
      )
      if (mutualMoney < 0) {
        const { cureTotal, socialSecurityExpense, thirdPartyExpense } =
          this.caseInfo
        // 如果计算的金额小于0元,则将金额还原到上一步的金额,并弹出错误提示
        calcHelpMoneyBak.cureTotal = cureTotal
        calcHelpMoneyBak.socialSecurityExpense = socialSecurityExpense
        calcHelpMoneyBak.thirdPartyExpense = thirdPartyExpense

        this.$message.error(
          '当前计算的最高互助金额小于0元，请填写正确的费用金额！'
        )
      } else {
        if (Number(mutualMoney) > 10000) mutualMoney = 10000
        calcHelpMoneyBak.mutualMoney = mutualMoney
      }
      this.calcHelpMoneyBak = calcHelpMoneyBak
    },

    /**
     * 显示申请次数-查看以往申请案件编号
     */
    onShowApplicationDialog() {
      this.applicationDialog = true
    },

    /**
     * 隐藏申请次数-查看以往申请案件编号
     */
    onHideApplicationDialog() {
      this.applicationDialog = false
    },

    /**
     * 跳转页面-案件详情页
     * @param {number} index 下标值
     */
    onNavsToCaseDetail(index) {
      const { recApplyList } = this.caseInfo
      const { from } = (this.$route && this.$route.query) || 'mytask' // 获取页面来源标识

      // 打开新标签页
      if (recApplyList && recApplyList[index]) {
        window.open(
          `/index/caseDetailV2/${recApplyList[index]}00?from=${from}`
        )
      }
    },

    /**
     * 计算受助人120天操作时天数
     * @param {string} date 申请日期（格式YYYY-MM-DD）
     */
    onCountingDays(date = '') {
      const { operatingTime } = this

      if (operatingTime > 0) {
        return operatingTime
      } else {
        const firstDate = new Date() // 当天时间
        const secondDate = new Date(date)
        const diff = Math.abs(firstDate.getTime() - secondDate.getTime())
        // const result = parseInt(diff / (1000 * 60 * 60 * 24))
        const result = parseInt(NP.divide(diff, NP.times(1000, 60, 60, 24)))
        this.operatingTime = result
        return result
      }
    },

    /**
     * 计划加入/退出信息转为表格数据
     * @param {number} index 计划下标（0: 抗癌 1: 意外）
     */
    joinExitTableData(index) {
      const info = this.caseInfo.joinExitInfos[index]
      if (!info || !Array.isArray(info.joinTimes)) return []

      return info.joinTimes.map((item, i) => ({
        joinTime: Array.isArray(item) ? item.join('、') : item,
        joinSource: info.joinSources && info.joinSources[i] ? info.joinSources[i] : '无',
        exitTime: info.exitTimes && info.exitTimes[i] ? info.exitTimes[i] : '无',
        exitReason: info.exitReasons && info.exitReasons[i] ? info.exitReasons[i] : '无'
      }))
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
